import i18n from '../i18n/config';

const baseUrl = process.env.REACT_APP_API_URL;

if (baseUrl === undefined) {
  throw new Error('REACT_APP_API_URL was not set');
}

/** Current UI language for API calls (e.g. journeys, journeyrefresh). Use when calling endpoints that accept a language parameter. */
export function getApiLanguage(): string {
  const lang = i18n.language?.split('-')[0];
  return lang || 'en';
}

export async function getApi(path: string, params: object) {
  if (path.startsWith('/')) {
    throw new Error("Path shouldnt start with /");
  }

  try {
    const url = new URL(path, baseUrl);
    const queryParams = new URLSearchParams(Object.entries(params).filter(([k, v]) => v !== undefined && v !== null));

    // Append the query parameters to the URL's search property
    url.search = queryParams.toString();

    return fetch(url.toString(), {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
      },
    }).then(async (res) => {
      const data = await res.json();
      if (!res.ok) {
        // If the response has an error message, use it; otherwise use a generic message
        const errorMessage = data?.error || `Server error: ${res.status} ${res.statusText}`;
        throw new Error(errorMessage);
      }
      return data;
    });
  } catch (error) {
    console.error('Failed to construct URL:', {
      baseUrl,
      path,
      error: error instanceof Error ? error.message : String(error)
    });
    throw new Error(`Invalid URL configuration. Base URL: ${baseUrl}, Path: ${path}`);
  }
}

export function postApi(path: string, params: object) {
  try {
    const url = new URL(path, baseUrl);
    return fetch(url.toString(), {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(params)
    });
  } catch (error) {
    console.error('Failed to construct URL:', {
      baseUrl,
      path,
      error: error instanceof Error ? error.message : String(error)
    });
    throw new Error(`Invalid URL configuration. Base URL: ${baseUrl}, Path: ${path}`);
  }
}
